export class Project {

  title;
  link;
  screenshot;
  reports = [];

  /**
   * Сколько всего отчетов у проекта по данным сервера. Может быть больше
   * длины reports: в ответ уходит не больше последней тысячи.
   *
   * Значение по умолчанию обязательно: сервер не присылает это поле у проектов
   * без задач, а объявления без инициализатора Babel в свойство объекта не
   * превращает — makeObservable тогда падает «Field not found».
   */
  reportsTotal = null;

  /**
   * Отчеты проекта уже у нас: либо пришли вместе со списком (активные проекты),
   * либо подтянуты по клику (архив). У архивного проекта до раскрытия — false,
   * см. AppStore.ensureProjectReports.
   */
  reportsLoaded = false;
  /** Отчеты подгружаются прямо сейчас. */
  reportsLoading = false;

  constructor(project) {
    Object.assign(this, project);

    this.reports = project.reports || [];
    // Присваиваем явно, а не полагаемся на объявления полей: makeObservable
    // аннотирует эти свойства и требует, чтобы они на объекте были.
    this.reportsTotal = project.reportsTotal ?? null;
    this.reportsLoaded = Array.isArray(project.reports);
    this.reportsLoading = false;

    if (!project.screenshot)
      this.screenshot = false;
    if (!project.cancelling)
      this.cancelling = false;
  }

  getDefaultTitle() {
    if (!this.type) return "Активность на площадке";
    if (this.type === "AVITO") return "Активность ОБЪЯВЛЕНИЯ";
    return `Активность на ${this.type}`;
  }

  get titleToShow() {
    const baseTitle = this.title || this.getDefaultTitle();
    return `${baseTitle} (#${this.id})`;
  }

  get fullTitle() {
    let t = this.title || this.getDefaultTitle();
    return `${t} (#${this.id})`;
  }

  // TODO: delete, update, pay, finish, archive...
}
